import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { INSERT_COMMITION, ORDER_COMMITION } from "../graphql/Mutation/OrderCommition.js";
import { toast } from "react-toastify";
import useScrollToTop from "../components/useScrollToTop.js";
import AdminHeader from "./AdminHeader.js";

const AdminComision = () => {
    const { data, refetch: orderRefetch } = useQuery(ORDER_COMMITION);
    const [sameDayOrderPercentage, setSameDayOrderPercentage] = useState("");
    const [upsertCommition] = useMutation(INSERT_COMMITION);

    const weights = [0.5, ...Array.from({ length: 30 }, (_, i) => i + 1)]; // 0.5 kg + 1kg to 30kg
    const [formData, setFormData] = useState({});

    const handleChange = (kg, type, value) => {
        setFormData((prev) => ({
            ...prev,
            [kg]: { ...prev[kg], [type]: value },
        }));
    };

    const handleSubmit = async () => {
        const weightCommissions = Object.keys(formData).map((weight) => ({
            weight: parseFloat(weight),
            cod_order_percentage: parseFloat(formData[weight].cod) || 0,
            freight_charge_percentage: parseFloat(formData[weight].prepaid) || 0,
        }));

        try {
            await upsertCommition({
                variables: { sameDayOrderPercentage: parseFloat(sameDayOrderPercentage) || 0, weightCommissions },

            });
            orderRefetch();
            toast.success("Commission updated successfully");
        } catch (err) {
            console.error("Error updating commission:", err);
        }
    };
    useScrollToTop();


    useEffect(() => {
        if (data && data?.getCommitionAmount) {
            const fetchedData = {};
            data?.getCommitionAmount?.weightCommissions.forEach((item) => {
                fetchedData[item.weight] = {
                    cod: item?.cod_order_percentage || "",
                    prepaid: item?.freight_charge_percentage || "",
                };
            });
            setFormData(fetchedData);
            setSameDayOrderPercentage(data?.getCommitionAmount.sameDay_order_percentage || "");
        }
    }, [data]);
    return (
        <>
            <AdminHeader />
            <div className="mb-4">
                <label className="block text-sm md:text-base font-medium mb-1">Same Day Order Commission (%)</label>
                <input
                    type="number"
                    className="w-full px-2 py-1 border rounded text-sm md:text-base"
                    placeholder="Enter percentage"
                    value={sameDayOrderPercentage}
                    onChange={(e) => setSameDayOrderPercentage(e.target.value)}
                />
            </div>
            <div className="overflow-x-auto p-4">
                <div className="w-full max-w-full overflow-auto">
                    <table className="w-full min-w-[600px] border border-gray-300">
                        <thead>
                            {/* First Row - Labels for Commission */}
                            <tr className="bg-slate-100 text-center text-sm md:text-base">
                                <th className="border px-2 md:px-4 py-2">No</th>
                                <th className="border px-2 md:px-4 py-2">kg</th>
                                <th className="border px-2 md:px-4 py-2">COD Commission</th>
                                <th className="border px-2 md:px-4 py-2">Freight Commission</th>
                                <th className="border px-2 md:px-4 py-2">Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            {weights.map((kg, index) => (
                                <tr key={kg} className="text-center text-sm md:text-base">
                                    <td className="border px-2 md:px-4 py-2">{index}</td>
                                    <td className="border px-2 md:px-4 py-2">{kg} kg</td>
                                    {/* COD Commission */}
                                    <td className="border px-2 md:px-4 py-2">
                                        {formData[kg]?.cod ? formData[kg]?.cod : "--"}
                                        <input
                                            type="number"
                                            className="w-full mt-1 px-2 py-1 border rounded text-sm md:text-base"
                                            placeholder="Enter COD value"
                                            value={formData[kg]?.cod || ""}
                                            onChange={(e) => handleChange(kg, "cod", e.target.value)}
                                        />
                                    </td>
                                    {/* Freight Commission */}
                                    <td className="border px-2 md:px-4 py-2">
                                        {formData[kg]?.prepaid ? formData[kg]?.prepaid : "--"}
                                        <input
                                            type="number"
                                            className="w-full mt-1 px-2 py-1 border rounded text-sm md:text-base"
                                            placeholder="Enter Prepaid value"
                                            value={formData[kg]?.prepaid || ""}
                                            onChange={(e) => handleChange(kg, "prepaid", e.target.value)}
                                        />
                                    </td>
                                    <td className="border px-2 md:px-4 py-2">--</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Submit Button */}
                <div className="mt-4 text-center">
                    <button
                        className="bg-slate-800 text-white px-4 py-2 rounded hover:bg-slate-700 text-sm md:text-base"
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>


        </>
    );
};

export default AdminComision;
